'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@headlessui/react';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { P3 } from '@/frontend/design-system/_marketing/typography/Paragraph';
import { Link } from '@/frontend/design-system/actions/Link';
import { elementarySchoolCourses, highSchoolCourses, universityCourses } from '../_components/NavigationItems';
export function CoursesOptions(t0) {
  const $ = _c(32);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      courses: elementarySchoolCourses,
      categoryIndex: 0,
      translationDirection: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [coursesDropdownState, setCoursesDropdownState] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      initial: _temp,
      animate: {
        opacity: 1,
        x: 0
      },
      exit: _temp2
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const variants = t2;
  const getCourses = _temp3;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = categoryIndex_0 => {
      setCoursesDropdownState(prevState => {
        const translationDirection = categoryIndex_0 === prevState.categoryIndex ? 0 : categoryIndex_0 > prevState.categoryIndex ? 1 : -1;
        const courses = getCourses(categoryIndex_0);
        return {
          courses,
          categoryIndex: categoryIndex_0,
          translationDirection
        };
      });
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleCategoryChange = t3;
  const t4 = `rounded-tl-3xl p-4 font-semibold text-sm leading-6 hover:bg-slate-100 hover:text-algosecondary hover:underline ${coursesDropdownState.categoryIndex === 0 ? "bg-white text-algosecondary" : ""}`;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => handleCategoryChange(0);
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4) {
    t6 = <Button className={t4} onClick={t5}>Szkoła podstawowa</Button>;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = `border-x-2 font-semibold text-sm leading-6 hover:bg-slate-100 hover:text-algosecondary hover:underline ${coursesDropdownState.categoryIndex === 1 ? "bg-white text-algosecondary" : ""}`;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => handleCategoryChange(1);
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t7) {
    t9 = <Button className={t7} onClick={t8}>Szkoła średnia</Button>;
    $[7] = t7;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = `rounded-tr-3xl font-semibold text-sm leading-6 hover:bg-slate-100 hover:text-algosecondary hover:underline ${coursesDropdownState.categoryIndex === 2 ? "bg-white text-algosecondary" : ""}`;
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => handleCategoryChange(2);
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== t10) {
    t12 = <Button className={t10} onClick={t11}>Studia</Button>;
    $[10] = t10;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== t12 || $[13] !== t6 || $[14] !== t9) {
    t13 = <div className="grid grid-cols-3 border-b-2 bg-slate-50">{t6}{t9}{t12}</div>;
    $[12] = t12;
    $[13] = t6;
    $[14] = t9;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const t14 = coursesDropdownState.translationDirection;
  const t15 = coursesDropdownState.categoryIndex;
  const t16 = coursesDropdownState.translationDirection;
  let t17;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      duration: 0.3
    };
    $[16] = t17;
  } else {
    t17 = $[16];
  }
  let t18;
  if ($[17] !== coursesDropdownState.courses || $[18] !== onClose) {
    let t19;
    if ($[20] !== onClose) {
      t19 = item => <div key={item.name} className="group relative flex gap-x-6 rounded-lg p-4 hover:bg-slate-50"><div className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-slate-50 group-hover:bg-white"><span className="h-6 w-6 text-slate-600 group-hover:fill-algosecondary group-hover:text-algosecondary" aria-hidden="true">{item.icon}</span></div><div><Link href={item.href} onClick={onClose} className="font-semibold text-slate-900">{item.name}<span className="absolute inset-0" /></Link><P3 className="mt-1">{item.description}</P3></div></div>;
      $[20] = onClose;
      $[21] = t19;
    } else {
      t19 = $[21];
    }
    t18 = coursesDropdownState.courses.map(t19);
    $[17] = coursesDropdownState.courses;
    $[18] = onClose;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  let t19;
  if ($[22] !== coursesDropdownState.categoryIndex || $[23] !== coursesDropdownState.translationDirection || $[24] !== t18) {
    t19 = <motion.div key={t15} custom={t16} variants={variants} initial="initial" animate="animate" exit="exit" transition={t17} className="grid grid-cols-1 gap-x-6 gap-y-1 p-4 lg:grid-cols-2">{t18}</motion.div>;
    $[22] = coursesDropdownState.categoryIndex;
    $[23] = coursesDropdownState.translationDirection;
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] !== coursesDropdownState.translationDirection || $[27] !== t19) {
    t20 = <AnimatePresence mode="wait" custom={t14}>{t19}</AnimatePresence>;
    $[26] = coursesDropdownState.translationDirection;
    $[27] = t19;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== t13 || $[30] !== t20) {
    t21 = <>{t13}{t20}</>;
    $[29] = t13;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  return t21;
}
function _temp3(categoryIndex) {
  switch (categoryIndex) {
    case 0:
      {
        return elementarySchoolCourses;
      }
    case 1:
      {
        return highSchoolCourses;
      }
    case 2:
      {
        return universityCourses;
      }
    default:
      {
        return elementarySchoolCourses;
      }
  }
}
function _temp2(direction_0) {
  return {
    opacity: 0,
    x: direction_0 * -500
  };
}
function _temp(direction) {
  return {
    opacity: 0,
    x: direction * 500
  };
}